import { useGetFetch } from '../utils/reactQuery';
import { pathToUrl } from '../utils/router';
import { ApiRoutesEnum } from '../utils/routes';

import { DictionaryType } from './types';

export type FetchCitiesDictionaryResponseType = DictionaryType[];

export const useGetCitiesDictionary = () =>
  useGetFetch<FetchCitiesDictionaryResponseType>({ url: pathToUrl(ApiRoutesEnum.dictionaryCities) });
